export default "__VITE_ASSET__CKocGtC3__"